import FiltersList from './component';

export default FiltersList;
